export default "__VITE_ASSET__033e3396__"